import { render, staticRenderFns } from "./ReportBillingCollectionEvent.vue?vue&type=template&id=42978cd6"
import script from "./ReportBillingCollectionEvent.vue?vue&type=script&lang=js"
export * from "./ReportBillingCollectionEvent.vue?vue&type=script&lang=js"
import style0 from "./ReportBillingCollectionEvent.vue?vue&type=style&index=0&id=42978cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports